/**
 * 防抖
 */
let timeout = null
let debounce = (fn, wait) => {
  if (timeout !== null) clearTimeout(timeout)
  timeout = setTimeout(fn, wait)
}
export default debounce






// WEBPACK FOOTER //
// ./src/utils/debounce.js